import { Collapse, Space } from "antd"
import { blue } from "@ant-design/colors"
import { useContext, useState } from "react"
import StepNumber from "./StepNumber"
import StepContent from "./StepContent"
import { Step } from "./sectionsList"
import { isItemChecked } from "./checklistModel"
import ChecklistContext from "./ChecklistContext"
import ExpandIcon from "../common/ExpandIcon"

type Props = {
  section: string
  steps: Step[]
}

const selectedPanelStyle = { border: `1px solid ${blue[4]}`, borderRadius: '10px', paddingBottom: 0 }

const Section = ({ section, steps }: Props) => {
  const { data, dispatch } = useContext(ChecklistContext)
  const [selectedPanels, setSelectedPanels] = useState<string[]>([])
  const updateSelectedPanels = (keys: string | string[] | undefined) => {
    if (keys === undefined) {
      setSelectedPanels([])
      return
    }

    if (typeof keys === 'string') {
      setSelectedPanels([keys])
      return
    }

    setSelectedPanels(keys)
  }

  const stepPanels = steps.map((x, i) => {
    const isChecked = isItemChecked(data, section, x.key)
    const onChange = () => dispatch({ type: 'CHECKMARK_CHANGED', section, key: x.key, value: !isChecked })
    return {
      key: x.key,
      label: <Space>
        <StepNumber step={i + 1} checked={isChecked} onChange={onChange} />
        {x.header}
      </Space>,
      style: selectedPanels.includes(x.key) ? selectedPanelStyle : undefined,
      children: <StepContent {...x} isChecked={isChecked} onChange={onChange} />
    }
  })

  return <div style={{ padding: '0 40px', margin: '12px 0' }}>
    <Collapse
      ghost
      accordion
      expandIconPosition="end"
      onChange={updateSelectedPanels}
      expandIcon={({ isActive }) => <ExpandIcon isExpanded={isActive ?? false} expandedColor={blue[4]} />}
      items={stepPanels}
    />
  </div>
}

export default Section
